/*@ngInject*/
const SubmissionFormViewerController = function ($scope, $stateParams, currentSubmissionModel) {

    $scope.submissionId = parseInt($stateParams.submissionId);

    $scope.viewModel = {
        formIsLoaded: false,
        formId: $stateParams.formId,
        effectiveDate: currentSubmissionModel.getCurrentSubmission().effectiveDate,
        currencyCode: currentSubmissionModel.getCurrentSubmission().currencyCode
    };
};

angular.module('gw-um-submission')
    .controller('submissionFormViewerController', SubmissionFormViewerController);
